// Class
import { SmartTagBase } from './smartTagBase';
// Model
import { SmartTagModel } from './smartTag.model';

export class SmartTagViewModel extends SmartTagModel {
	viewQuality?: string;
	viewAffect?: string;

	constructor() {
		super();
		this.viewQuality = '';
		this.viewAffect = '';
	}
}

export class SmartTagView extends SmartTagBase {

	/**
	 * Renderer
	 * @param data SmartTagViewModel
	 */
	public render(data: SmartTagViewModel, version?: string): string {
		this.getData(data);

		return this.getOutputData(version || 'v1');
	}

	private getData(data: SmartTagViewModel): void {

		const title = data.title || data.subCategory || '';
		const quality = data.viewQuality || '';
		const affect = data.viewAffect || '';
		const description = data.description?.trim() || '';

		if (title !== '') {
			this.title = `<span title="${title}">Type: ${title}</span>`;
		}
		if (quality !== '') {
			this.addText(`<span title="${quality}">View Quality: ${quality}</span>`);
		}
		if (affect !== '') {
			this.addText(`<span title="${affect}">View Affect: ${affect}</span>`);
		}
		if (description !== '') {
			this.addText(`<span title="${description}">Description: ${description}</span>`);
		}
	}

}
